// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * The following are shared across all platforms and apps
 */
.dashboard-container .dashboard-header {
  font-family: "OpenSans-Bold";
  margin-top: 30px;
  border-bottom: 1px solid #dee2e6;
}
.dashboard-container .date-selector:read-only {
  background-color: white;
}
.dashboard-container .label-filters {
  line-height: 2rem;
  font-family: "OpenSans-Bold";
  color: var(--undp-jtf-btn-dark-color);
  margin-right: 10px;
}
.dashboard-container .filters {
  margin-bottom: 20px;
  font-family: "OpenSans-Regular";
  color: var(--undp-jtf-btn-dark-color);
}
.dashboard-container .filter-wrapper {
  margin-top: 20px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  gap: 1rem;
  margin-right: 10px;
}
@media (max-width: 1192px) {
  .dashboard-container .filter-wrapper {
    flex-direction: column;
  }
}
.dashboard-container .filter-wrapper div:first-child {
  margin-right: 1.5 rem;
}
@media (max-width: 1192px) {
  .dashboard-container .filter-wrapper div:first-child {
    margin-right: 0;
  }
}
.dashboard-container .filter-wrapper .datepicker-container {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex: 1 1;
  justify-content: space-around;
  gap: 8px;
}
@media (max-width: 890px) and (min-width: 768px) {
  .dashboard-container .filter-wrapper .datepicker-container {
    flex-direction: column;
  }
}
@media (max-width: 512px) {
  .dashboard-container .filter-wrapper .datepicker-container {
    flex-direction: column;
  }
}
.dashboard-container .filter-wrapper .input-group {
  width: auto;
  color: var(--undp-jtf-btn-dark-color);
}
.dashboard-container .dashboard-cards {
  margin-top: 50px;
}
.dashboard-container .dashboard-cards .main-card {
  height: 100%;
}
.dashboard-container .dashboard-cards .card .card-header {
  font-family: "OpenSans-Bold";
  color: var(--undp-jtf-btn-dark-color);
}
.dashboard-container .dashboard-cards .card .card-body h1 {
  color: var(--undp-jtf-btn-dark-color);
  font-size: 5rem;
}
.dashboard-container .dashboard-cards .card .card-body .pie-chart-container {
  margin-top: 20px;
  padding-top: 10px;
}

.dashboard-row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
}
@media (max-width: 768px) {
  .dashboard-row {
    flex-direction: column;
    align-items: center;
  }
}

.col-width {
  width: 48%;
}
@media (max-width: 768px) {
  .col-width {
    width: 95%;
  }
}

.card-select {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 15px;
}
@media (max-width: 420px) {
  .card-select {
    flex-direction: column;
    gap: 10px;
  }
}

.dropdown-select {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 40%;
}
@media (max-width: 420px) {
  .dropdown-select {
    width: 100%;
  }
}

.date-filter {
  width: 50%;
  border: 0px;
  margin-bottom: 20px;
}
@media (max-width: 920px) {
  .date-filter {
    width: 55%;
  }
}
@media (max-width: 420px) {
  .date-filter {
    width: 100%;
  }
}

@media all and (min-width: 67vw) {
  .filter-section {
    display: inline-grid;
  }
}
.pie-chart-font {
  font-size: medium;
}

.custom-ui {
  color: var(--undp-jtf-primary-color);
}`, "",{"version":3,"sources":["webpack://./libs/scss/_index.scss","webpack://./apps/hybrid-app/src/app/features/dashboard/components/dashboard.component.scss","webpack://./apps/hybrid-app/src/scss/_variables.scss"],"names":[],"mappings":"AAAA;;EAAA;ACGE;EACE,4BCKkB;EDJlB,gBAAA;EACA,gCAAA;AACJ;AAGI;EACE,uBAAA;AADN;AAKE;EACE,iBAAA;EACA,4BCRkB;EDSlB,qCAAA;EACA,kBAAA;AAHJ;AAME;EACE,mBAAA;EACA,+BCnBmB;EDoBnB,qCAAA;AAJJ;AAOE;EACE,gBAAA;EACA,mBAAA;EAEA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AANJ;AAQI;EATF;IAUI,sBAAA;EALJ;AACF;AAOI;EACE,qBAAA;AALN;AAOM;EAHF;IAII,eAAA;EAJN;AACF;AAOI;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,6BAAA;EACA,QAAA;AALN;AAOM;EARF;IASI,sBAAA;EAJN;AACF;AAMM;EAZF;IAaI,sBAAA;EAHN;AACF;AAKI;EACE,WAAA;EACA,qCAAA;AAHN;AAmBE;EACE,gBAAA;AAjBJ;AAmBI;EACE,YAAA;AAjBN;AAqBM;EACE,4BCnFc;EDoFd,qCAAA;AAnBR;AAuBQ;EACE,qCAAA;EACA,eAAA;AArBV;AAwBQ;EACE,gBAAA;EACA,iBAAA;AAtBV;;AA6BA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,6BAAA;AA1BF;AA4BE;EANF;IAOI,sBAAA;IACA,mBAAA;EAzBF;AACF;;AA4BA;EACE,UAAA;AAzBF;AA0BE;EAFF;IAGI,UAAA;EAvBF;AACF;;AA0BA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;AAvBF;AAyBE;EARF;IASI,sBAAA;IACA,SAAA;EAtBF;AACF;;AA0BA;EACE,aAAA;EACA,eAAA;EACA,oBAAA;EACA,UAAA;AAvBF;AAyBE;EANF;IAOI,WAAA;EAtBF;AACF;;AAyBA;EACE,UAAA;EACA,WAAA;EACA,mBAAA;AAtBF;AAyBE;EANF;IAOI,UAAA;EAtBF;AACF;AAwBE;EAVF;IAWI,WAAA;EArBF;AACF;;AAwBA;EACE;IACE,oBAAA;EArBF;AACF;AAwBA;EACE,iBAAA;AAtBF;;AAyBA;EACE,oCAAA;AAtBF","sourcesContent":["/**\n * The following are shared across all platforms and apps\n */\n\n// shared variables\n@import 'variables';\n\n// create/import other scss files or define as needed...\n","@import '../../../../scss/variables';\n\n.dashboard-container {\n  .dashboard-header {\n    font-family: $secondary-font-bold;\n    margin-top: 30px;\n    border-bottom: 1px solid #dee2e6;\n  }\n\n  .date-selector {\n    &:read-only {\n      background-color: white;\n    }\n  }\n\n  .label-filters {\n    line-height: 2rem;\n    font-family: $secondary-font-bold;\n    color: var(--undp-jtf-btn-dark-color);\n    margin-right: 10px;\n  }\n\n  .filters {\n    margin-bottom: 20px;\n    font-family: $primary-font-regular;\n    color: var(--undp-jtf-btn-dark-color);\n  }\n\n  .filter-wrapper {\n    margin-top: 20px;\n    margin-bottom: 10px;\n    // float: left;\n    display: flex;\n    flex-direction: row;\n    gap: 1rem;\n    margin-right: 10px;\n\n    @media (max-width: 1192px) {\n      flex-direction: column;\n    }\n\n    div:first-child {\n      margin-right: 1.5 rem;\n\n      @media (max-width: 1192px) {\n        margin-right: 0;\n      }\n    }\n\n    .datepicker-container {\n      width: 100%;\n      display: flex;\n      flex-direction: row;\n      flex: 1 1;\n      justify-content: space-around;\n      gap: 8px;\n\n      @media (max-width: 890px)  and (min-width: 768px) {\n        flex-direction: column;\n      }\n\n      @media (max-width: 512px) {\n        flex-direction: column;\n      }\n    }\n    .input-group {\n      width: auto;\n      color: var(--undp-jtf-btn-dark-color);\n    }\n  }\n\n  // .date-filter {\n  //   // width: 40%;\n  //   width: 80%;\n  //   border: 0px;\n  //   margin-bottom: 20px;\n  //   margin-top: 15px;\n\n  //   // @media (max-width: 920px) {\n  //   //   width: 100%;\n  //   // }\n  // }\n\n  .dashboard-cards {\n    margin-top: 50px;\n\n    .main-card {\n      height: 100%;\n    }\n\n    .card {\n      .card-header {\n        font-family: $secondary-font-bold;\n        color: var(--undp-jtf-btn-dark-color);\n      }\n\n      .card-body {\n        h1 {\n          color: var(--undp-jtf-btn-dark-color);\n          font-size: 5rem;\n        }\n\n        .pie-chart-container {\n          margin-top: 20px;\n          padding-top: 10px;\n        }\n      }\n    }\n  }\n}\n\n.dashboard-row {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-around;\n\n  @media (max-width: 768px) {\n    flex-direction: column;\n    align-items: center;\n  }\n}\n\n.col-width {\n  width: 48%;\n  @media (max-width: 768px) {\n    width: 95%;\n  }\n}\n\n.card-select {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding-left: 10px;\n  padding-right: 10px;\n  padding-top: 15px;\n\n  @media (max-width: 420px) {\n    flex-direction: column;\n    gap: 10px;\n  }\n\n}\n\n.dropdown-select {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  width: 40%;\n\n  @media (max-width: 420px) {\n    width: 100%;\n  }\n}\n\n.date-filter {\n  width: 50%;\n  border: 0px;\n  margin-bottom: 20px;\n  // margin-top: 15px;\n\n  @media (max-width: 920px) {\n    width: 55%;\n  }\n\n  @media (max-width: 420px) {\n    width: 100%;\n  }\n}\n\n@media all and (min-width: 67vw) {\n  .filter-section {\n    display: inline-grid;\n  }\n}\n\n.pie-chart-font {\n  font-size: medium;\n}\n\n.custom-ui {\n  color: var(--undp-jtf-primary-color);\n}\n","@import '@eview/scss/index';\n\n$primary-font: \"Montserrat\";\n$primary-font-bold: \"OpenSans-Bold\";\n$primary-font-medium: \"OpenSans-Light\";\n$primary-font-regular: \"OpenSans-Regular\";\n$primary-font-light: \"OpenSans-Light\";\n$primary-font-thin: \"OpenSans-Thin\";\n$secondary-font : \"Lato\";\n$secondary-font-bold: \"OpenSans-Bold\";\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
